<div class="col-lg-12">
    <div class="card">
        <div class="card-body">
            <h2>{{ news.news.title }}</h2>

            <owl-carousel-o
                    *ngIf="news.images.length > 0"
                    [options]="carouselOption1"
                    class="full-width">
                <ng-template *ngFor="let image of news.images" carouselSlide>
                    <img
                            [src]="constants.imagesUrl() + '/images/1920x1080/' + image.type + '/' + image.name + '/'"/>
                </ng-template>
            </owl-carousel-o>

            <div id="news-text" [innerHTML]="news.news.text"></div>
        </div>
    </div>
</div>
